// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ScoutMembership {
  id: string;
  name: string;
  slug: string;
  price_cents: number;
}

export const useScoutMemberships = (scoutId?: string) => {
  const [memberships, setMemberships] = useState<ScoutMembership[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchScoutMemberships = async () => {
    if (!scoutId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log('🔍 Fetching memberships assigned to scout:', scoutId);
      
      const { data, error } = await supabase
        .from('scout_membership_assignments')
        .select(`
          membership_id,
          memberships!inner(
            id,
            name,
            slug,
            price_cents
          )
        `)
        .eq('scout_id', scoutId);

      if (error) {
        console.error('❌ Error fetching scout memberships:', error);
        return;
      }

      // Transform the data to a flat structure
      const scoutMemberships: ScoutMembership[] = data?.map(assignment => ({
        id: (assignment.memberships as any).id,
        name: (assignment.memberships as any).name,
        slug: (assignment.memberships as any).slug,
        price_cents: (assignment.memberships as any).price_cents
      })) || [];

      console.log('✅ Scout memberships fetched:', scoutMemberships.length);
      setMemberships(scoutMemberships);
    } catch (err) {
      console.error('Error fetching scout memberships:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScoutMemberships();
  }, [scoutId]);

  return {
    memberships,
    loading,
    refetch: fetchScoutMemberships
  };
};